import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';

import { ExtendedAttributeFilterInterface } from 'app/library/all-users/interfaces/extended-attribute-filer.interface';
import { TrainingApprovalRequest } from 'app/library/training-approval-request/models/training-approval-request.model';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';

export class SetTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] SetTrainingApprovalTeamRequest';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class UnsetTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] UnsetTrainingApprovalTeamRequest';
}

export class FetchTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamRequest';

    constructor(public payload: string) {}
}

export class FetchTrainingApprovalTeamRequestSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamRequestSuccess';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class FetchTrainingApprovalTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamRequestFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] CreateTrainingApprovalTeamRequest';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class CreateTrainingApprovalTeamRequestSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] CreateTrainingApprovalTeamRequestSuccess';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class CreateTrainingApprovalTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] CreateTrainingApprovalTeamRequestFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] UpdateTrainingApprovalTeamRequest';

    constructor(public payload: string) {}
}

export class UpdateTrainingApprovalTeamRequestSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] UpdateTrainingApprovalTeamRequestSuccess';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class UpdateTrainingApprovalTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] UpdateTrainingApprovalTeamRequestFailure';

    constructor() {}
}

export class DeleteTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] DeleteTrainingApprovalTeamRequest';

    constructor(public payload: string) {}
}

export class DeleteTrainingApprovalTeamRequestSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] DeleteTrainingApprovalTeamRequestSuccess';

    constructor(public payload: string) {}
}

export class DeleteTrainingApprovalTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] DeleteTrainingApprovalTeamRequestFailure';

    constructor(public payload: string) {}
}

export class SetTrainingApprovalTeamRequests {
    static readonly type = '[TrainingApprovalTeamRequest] SetTrainingApprovalTeamRequests';

    constructor(public payload: TrainingApprovalRequest[]) {}
}

export class FetchTrainingApprovalTeamRequests {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamRequests';

    constructor(
        public payload?: {
            teamId: string;
            search: string;
            pageSize: number;
            pageIndex: number;
            includeSubteams: boolean;
            statusesIds?: string[];
            requestDate?: ExtendedAttributeFilterInterface;
            lastUpdate?: ExtendedAttributeFilterInterface;
            extendedAttributesFilters?: ExtendedAttributeFilterInterface[];
            columns?: string[];
        }
    ) {}
}

export class FetchTrainingApprovalTeamRequestsSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamRequestsSuccess';
}

export class FetchTrainingApprovalTeamRequestsFailure {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamRequestsFailure';
}

export class SearchTrainingApprovalTeamRequests {
    static readonly type = '[TrainingApprovalTeamRequest] SearchTrainingApprovalTeamRequests';

    constructor(public payload: string) {}
}

export class FetchTrainingApprovalTeamOverview {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamOverview';

    constructor(
        public payload: {
            teamId: string;
            includeSubteams: boolean;
        }
    ) {}
}

export class FetchTrainingApprovalTeamOverviewSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamOverviewSuccess';

    constructor(public payload: {}) {}
}

export class FetchTrainingApprovalTeamOverviewFailure {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamOverviewFailure';

    constructor() {}
}

export class FetchTrainingApprovalTeamMemberOverview {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamMemberOverview';

    constructor(
        public payload: {
            teamId: string;
            userId: string;
        }
    ) {}
}

export class FetchTrainingApprovalTeamMemberOverviewSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamMemberOverviewSuccess';

    constructor(public payload: {}) {}
}

export class FetchTrainingApprovalTeamMemberOverviewFailure {
    static readonly type = '[TrainingApprovalTeamRequest] FetchTrainingApprovalTeamMemberOverviewFailure';

    constructor() {}
}

export class RejectTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] RejectTrainingApprovalTeamRequest';

    constructor(
        public payload: {
            id: string;
            reason: string;
        }
    ) {}
}

export class RejectTrainingApprovalTeamRequestSucceess {
    static readonly type = '[TrainingApprovalTeamRequestt] RejectTrainingApprovalTeamRequestSucceess';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class RejectTrainingApprovalTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] RejectTrainingApprovalTeamRequestFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class ApproveTrainingApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] ApproveTrainingApprovalTeamRequest';

    constructor(
        public payload: {
            id: string;
            reason: string;
        }
    ) {}
}

export class ApproveTrainingApprovalTeamRequestSucceess {
    static readonly type = '[TrainingApprovalTeamRequest] ApproveTrainingApprovalTeamRequestSucceess';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class ApproveTrainingApprovalTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] ApproveTrainingApprovalTeamRequestFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class ChangeTeamOfApprovalTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] ChangeTeamOfApprovalTeamRequest';

    constructor(
        public payload: {
            approvalRequestId: string;
            targetTeamId: string;
            reason: string;
        }
    ) {}
}

export class ChangeTeamOfApprovalTeamRequestSucceess {
    static readonly type = '[TrainingApprovalTeamRequest] ChangeTeamOfApprovalTeamRequestSucceess';

    constructor(public payload: TrainingApprovalRequest) {}
}

export class ChangeTeamOfApprovalTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] ChangeTeamOfApprovalTeamRequestFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class ReassignApproverTeamRequest {
    static readonly type = '[TrainingApprovalTeamRequest] ReassignApproverTeamRequest';

    constructor(
        public payload?: {
            id: string;
            actorId: string;
            reason: string;
        }
    ) {}
}

export class ReassignApproverTeamRequestSuccess {
    static readonly type = '[TrainingApprovalTeamRequest] ReassignApproverTeamRequestSuccess';
}

export class ReassignApproverTeamRequestFailure {
    static readonly type = '[TrainingApprovalTeamRequest] ReassignApproverTeamRequestFailure';
}
